/* ==========================================================================
   Vapor Space 2.0 — predictive search
   --------------------------------------------------------------------------
   Layered on top of a real GET form that already works without JavaScript.
   If this file fails to load, the search box still submits to /search.
   ========================================================================== */

(function () {
  'use strict';

  var VS = (window.VS = window.VS || {});

  var overlay = document.getElementById('vs-search');
  if (!overlay) return;

  var input = overlay.querySelector('[data-vs-search-input]');
  var results = overlay.querySelector('[data-vs-search-results]');
  var defaults = overlay.querySelector('[data-vs-search-default]');

  var controller = null;
  var timer = null;
  var lastQuery = '';

  VS.on('click', '[data-vs-search-open]', function (e, trigger) {
    e.preventDefault();
    VS.Overlay.open(overlay, trigger);
  });

  function showDefault() {
    if (!results) return;
    results.innerHTML = '';
    if (defaults) results.appendChild(defaults);
  }

  function render(data, query) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (!products.length) {
      results.innerHTML =
        '<p class="empty-state">' +
        (VS.strings.noResults || 'No results for "__TERMS__".').replace('__TERMS__', escapeHtml(query)) +
        '</p>';
      return;
    }

    var list = document.createElement('div');
    list.className = 'search__list';

    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'sresult';
      a.href = p.url;

      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : null;

      a.innerHTML =
        '<span class="sresult__media">' +
        (img ? '<img src="' + escapeHtml(img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
        '</span>' +
        '<span class="sresult__info">' +
        '<span class="sresult__title">' +
        escapeHtml(p.title) +
        '</span>' +
        (p.vendor ? '<span class="sresult__meta">' + escapeHtml(p.vendor) + '</span>' : '') +
        '</span>' +
        '<span class="sresult__price">' +
        (p.available === false
          ? '<span class="sresult__meta">' + (VS.strings.soldOut || 'Sold out') + '</span>'
          : formatSuggestPrice(p.price)) +
        '</span>';

      list.appendChild(a);
    });

    results.innerHTML = '';
    results.appendChild(list);

    var all = document.createElement('a');
    all.className = 'search__all';
    all.href = VS.routes.search + '?q=' + encodeURIComponent(query) + '&type=product';
    all.textContent = 'See all results';
    results.appendChild(all);
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  // Predictive search returns `price` as a decimal string in major units —
  // "30.00" — whereas the cart and product JSON return integer minor units
  // (3000). VS.formatMoney takes minor units and divides by 100, so passing
  // p.price straight in printed every result at a hundredth of its price:
  // a Dhs. 30.00 product showed as Dhs. 0.30.
  //
  // Converted here rather than in VS.formatMoney because every other caller
  // already passes minor units correctly. Math.round is load-bearing:
  // parseFloat('19.99') * 100 is 1998.9999999999998. A missing or malformed
  // price renders nothing rather than "Dhs. NaN".
  function formatSuggestPrice(amount) {
    var cents = Math.round(parseFloat(amount) * 100);
    return isFinite(cents) ? VS.formatMoney(cents) : '';
  }

  function search(query) {
    // Abort the in-flight request before starting another. Without this,
    // responses can land out of order and a stale query overwrites a newer
    // one — the classic autocomplete race.
    if (controller) controller.abort();
    controller = new AbortController();

    var url =
      VS.routes.predictiveSearch +
      '?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        render(data, query);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        // A failed suggestion lookup is not worth an error message — the form
        // underneath still submits and gets real results.
        showDefault();
      });
  }

  if (input) {
    input.addEventListener('input', function () {
      var query = input.value.trim();

      clearTimeout(timer);

      if (query.length < 2) {
        if (controller) controller.abort();
        showDefault();
        lastQuery = '';
        return;
      }

      if (query === lastQuery) return;
      lastQuery = query;

      // Debounce. Shopify rate-limits predictive search, and a request per
      // keystroke burns that budget for no benefit.
      timer = setTimeout(function () {
        search(query);
      }, 220);
    });
  }

  document.addEventListener('vs:overlay:close', function (e) {
    if (e.detail.el !== overlay) return;
    if (input) input.value = '';
    lastQuery = '';
    showDefault();
  });
})();
